import { createContext } from 'react';
import { noop } from 'lodash-es';

export const ZipLongDistanceConfirmContext = createContext({
  showZipLongDistanceConfirm: false,
  setZipLongDistanceConfirm: noop,
});
